import * as auth from '@/store/auth.actions';
import * as doc from '@/store/documents.actions';
import * as log from '@/store/log.actions';
import * as sett from '@/store/settings.actions';
import * as org from '@/store/organization.actions';
import * as fold from '@/store/folders.actions';
import * as filefold from '@/store/filefolders.actions';
import * as sign from '@/store/sign.actions';
import * as userSettings from '@/store/userSettings.action';
import * as settTmp from '@/store/settings.temp.actions';
import * as componentsActions from '@/store/components.actions';
import * as modulesActions from '@/store/modules.actions';
import * as documentSignaturesTempActions from '@/store/document-signatures.temp.actions';

const authPrefix = 'auth/';
const docPrefix = 'documents/';
const logPrefix = 'log/';
const settPrefix = 'settings/';
const orgPrefix = 'organization/';
const foldersPrefix = 'folders/';
const signPrefix = 'sign/';
const userSettingsPrefix = 'userSettings/';
const filefoldersPrefix = 'filefolders/';
const settingsTemp = 'settingsTemp/';
const componentsPrefix = 'components/';
const modulesPrefix = 'modules/';
const documentSignaturesTempPrefix = 'documentSignaturesTemp/';

export const actions = {
  AUTH_ACT_REFRESHTOKEM: authPrefix + auth.ACT_REFRESHTOKEM,
  AUTH_ACT_CHANGEPASS: authPrefix + auth.ACT_CHANGEPASS,
  AUTH_ACT_LOGIN: authPrefix + auth.ACT_LOGIN,
  AUTH_ACT_LOGINGOOGLE: authPrefix + auth.ACT_LOGINGOOGLE,
  AUTH_ACT_LOGINROUMING: authPrefix + auth.ACT_LOGINROUMING,
  AUTH_ACT_LOGINFACEBOOK: authPrefix + auth.ACT_LOGINFACEBOOK,
  AUTH_ACT_LOGINMICROSOFT: authPrefix + auth.ACT_LOGINMICROSOFT,
  AUTH_ACT_LOGINAPPLE: authPrefix + auth.ACT_LOGINAPPLE,
  AUTH_ACT_LOGINECP: authPrefix + auth.ACT_LOGINECP,
  AUTH_ACT_LOGOUT: authPrefix + auth.ACT_LOGOUT,
  AUTH_ACT_SAVELOGIN: authPrefix + auth.ACT_SAVELOGIN,
  AUTH_ACT_AVATAR: authPrefix + auth.ACT_SAVEAVATAR,
  AUTH_GET_LASTLOGINGET: authPrefix + auth.GET_LASTLOGINGET,
  AUTH_GET_SAVELOGIN: authPrefix + auth.GET_SAVELOGIN,
  AUTH_GET_ISLOGINEDGET: authPrefix + auth.GET_ISLOGINEDGET,
  AUTH_GET_LOGINUSERGET: authPrefix + auth.GET_LOGINUSERGET,
  AUTH_GET_AVATAR: authPrefix + auth.GET_AVATAR,
  AUTH_GET_TOKENSGET: authPrefix + auth.GET_TOKENSGET,
  AUTH_GET_ACCESTOKENGET: authPrefix + auth.GET_ACCESTOKENGET,
  AUTH_GET_ACTIONSGET: authPrefix + auth.GET_ACTIONSGET,
  AUTH_GET_EMAILUSERGET: authPrefix + auth.GET_EMAILUSERGET,
  AUTH_GET_ORGGET: authPrefix + auth.GET_ORGGET,
  AUTH_GET_SESSIONID: authPrefix + auth.GET_SESSIONID,
  AUTH_GET_ORGID: authPrefix + auth.GET_ORGID,
  AUTH_GET_USERMODULES: authPrefix + auth.GET_USERMODULES,
  AUTH_GET_ORGMODULES: authPrefix + auth.GET_ORGMODULES,
  AUTH_GET_USERCODE: authPrefix + auth.GET_USERCODE,
  AUTH_GET_USERROLE: authPrefix + auth.GET_USERROLE,
  AUTH_MUT_LOGIN: authPrefix + auth.MUT_LOGIN,
  AUTH_MUT_LOGOUT: authPrefix + auth.MUT_LOGOUT,
  AUTH_MUT_UPDATEUSERNAME: authPrefix + auth.MUT_USERNAME,

  DOC_ACT_LOADCOUNTERS: docPrefix + doc.ACT_LOADCOUNTERS,
  DOC_ACT_LOADBALANCE: docPrefix + doc.ACT_LOADBALANCE,
  DOC_GET_COUNTERS: docPrefix + doc.GET_COUNTERS,
  DOC_GET_BALANCE: docPrefix + doc.GET_BALANCE,
  DOC_ACT_SETFINDSTRING: docPrefix + doc.ACT_SETFINDSTRING,
  DOC_GET_FINDSTRING: docPrefix + doc.GET_FINDSTRING,
  DOC_MUT_ADDBALANCE: docPrefix + doc.MUT_ADDBALANCE,
  DOC_MUT_ADDCOUNTERS: docPrefix + doc.MUT_ADDCOUNTERS,

  USETT_ACT_USERSETTINGS: userSettingsPrefix + userSettings.ACT_USERSETTINGS,
  USETT_GET_USERSETTINGS: userSettingsPrefix + userSettings.GET_USERSETTINGS,
  USETT_MUT_USERSETTINGS: userSettingsPrefix + userSettings.MUT_USERSETTINGS,

  LOG_GET_MESSAGES: logPrefix + log.GET_MESSAGES,
  LOG_GET_MESSAGE: logPrefix + log.GET_MESSAGE,
  LOG_GET_SETTINGS: logPrefix + log.GET_SETTINGS,
  LOG_GET_VERSION: logPrefix + log.GET_VERSION,

  LOG_MUT_MESSAGE: logPrefix + log.MUT_MESSAGE,
  LOG_MUT_MESSAGES: logPrefix + log.MUT_MESSAGES,
  LOG_MUT_CLEAROLDSTATE: logPrefix + log.MUT_CLEAROLDSTATE,
  LOG_MUT_MARK_MESSAGE_AS_REPORTED: logPrefix + log.MUT_MARK_MESSAGE_AS_REPORTED,
  LOG_MUT_REMOVE_MESSAGES: logPrefix + log.MUT_REMOVE_MESSAGES,
  LOG_MUT_REMOVE_ALL_MESSAGES: logPrefix + log.MUT_REMOVE_ALL_MESSAGES,
  LOG_MUT_SETTINS: logPrefix + log.MUT_SETTINS,
  LOG_MUT_VERSION: logPrefix + log.MUT_VERSION,

  SETT_ACT_DOCVIEWPDFWIDTHSET: settPrefix + sett.ACT_DOCVIEWPDFWIDTHSET,
  SETT_ACT_DOCVIEWSHOWNAVIGATIONSET: settPrefix + sett.ACT_DOCVIEWSHOWNAVIGATIONSET,
  SETT_ACT_APPSET: settPrefix + sett.ACT_APPSET,
  SETT_ACT_CONFIG: settPrefix + sett.ACT_CONFIG,
  SETT_ACT_DOCCOLUMNS: settPrefix + sett.ACT_DOCCOLUMNS,
  SETT_ACT_WORDWRAP: settPrefix + sett.ACT_WORDWRAP,
  SETT_GET_LOCALEGET: settPrefix + sett.GET_LOCALEGET,
  SETT_GET_APIURLGET: settPrefix + sett.GET_APIURLGET,
  SETT_GET_APIHOSTGET: settPrefix + sett.GET_APIHOSTGET,
  SETT_GET_CURENTVERSIONGET: settPrefix + sett.GET_CURENTVERSIONGET,
  SETT_GET_DOCVIEWPDFWIDTHGET: settPrefix + sett.GET_DOCVIEWPDFWIDTHGET,
  SETT_GET_DOCVIEWSHOWNAVIGATIONGET: settPrefix + sett.GET_DOCVIEWSHOWNAVIGATIONGET,
  SETT_GET_APPSET: settPrefix + sett.GET_APPSET,
  SETT_GET_CFG_WAITER: settPrefix + sett.GET_CFG_WAITER,
  SETT_GET_STG_WAITER: settPrefix + sett.GET_STG_WAITER,
  SETT_GET_SERV_VERS: settPrefix + sett.GET_SERV_VERS,
  SETT_GET_DOCCOLUMNS: settPrefix + sett.GET_DOCCOLUMNS,
  SETT_GET_ISSHOWORGDOC: settPrefix + sett.GET_ISSHOWORGDOC,
  SETT_GET_WORDWRAP: settPrefix + sett.GET_WORDWRAP,
  SETT_GET_SERV_TIME: settPrefix + sett.GET_SERV_TIME,
  SETT_MUT_LOCALESET: settPrefix + sett.MUT_LOCALESET,
  SETT_MUT_DOCVIEWPDFWIDTHSET: settPrefix + sett.MUT_DOCVIEWPDFWIDTHSET,
  SETT_MUT_DOCVIEWSHOWNAVIGATIONSET: settPrefix + sett.MUT_DOCVIEWSHOWNAVIGATIONSET,
  SETT_MUT_CFG: settPrefix + sett.MUT_CFG,
  SETT_MUT_APPSET: settPrefix + sett.MUT_APPSET,
  SETT_MUT_CLEAR_OLD_STATE: settPrefix + sett.MUT_CLEAR_OLD_STATE,
  SETT_MUT_SERV_VERS: settPrefix + sett.MUT_SERV_VERS,
  SETT_MUT_DOCCOLUMNS: settPrefix + sett.MUT_DOCCOLUMNS,
  SETT_MUT_ISSHOWORGDOC: settPrefix + sett.MUT_ISSHOWORGDOC,
  SETT_MUT_WORDWRAP: settPrefix + sett.MUT_WORDWRAP,
  SETT_MUT_SERV_TIME: settPrefix + sett.MUT_SERV_TIME,

  ORG_ACT_DETAILS: orgPrefix + org.ACT_DETAILS,
  ORG_MUT_DETAILSSET: orgPrefix + org.MUT_DETAILSSET,
  ORG_MUT_DETAILSCLEAR: orgPrefix + org.MUT_DETAILSCLEAR,
  ORG_MUT_MYORGSET: orgPrefix + org.MUT_MYORGSET,
  ORG_MUT_MYORGCLEAR: orgPrefix + org.MUT_MYORGCLEAR,
  ORG_GET_DETAILS: orgPrefix + org.GET_DETAILS,
  ORG_GET_MYORG: orgPrefix + org.GET_MYORG,

  FOLD_ACT_LOADFOLDERS: foldersPrefix + fold.ACT_LOADFOLDERS,
  FOLD_GET_FOLDERS: foldersPrefix + fold.GET_FOLDERS,

  SIGN_GET_SELECTEDCN: signPrefix + sign.GET_SELECTEDCN,
  SIGN_GET_AUTOSELECTCN: signPrefix + sign.GET_AUTOSELECTCN,
  SIGN_GET_SELECTEDTAB: signPrefix + sign.GET_SELECTEDTAB,
  SIGN_GET_SELECTEDCNSEAL: signPrefix + sign.GET_SELECTEDCNSEAL,
  SIGN_GET_AUTOSELECTCNSEAL: signPrefix + sign.GET_AUTOSELECTCNSEAL,
  SIGN_GET_SELECTEDTABSEAL: signPrefix + sign.GET_SELECTEDTABSEAL,
  SIGN_GET_CLOUD: signPrefix + sign.GET_CLOUD,
  SIGN_GET_CLOUD_SEAL: signPrefix + sign.GET_CLOUD_SEAL,
  SIGN_GET_CLOUD_PROVIDER: signPrefix + sign.GET_CLOUD_PROVIDER,
  SIGN_GET_CLOUD_PROVIDER_SEAL: signPrefix + sign.GET_CLOUD_PROVIDER_SEAL,
  SIGN_GET_USER_CERT: signPrefix + sign.GET_USER_CERT,
  SIGN_GET_SHOWALLDEVICES: signPrefix + sign.GET_SHOWALLDEVICES,
  SIGN_GET_SHOWALLDEVICES_SEAL: signPrefix + sign.GET_SHOWALLDEVICES_SEAL,
  SIGN_GET_SELECTEDDEVICE: signPrefix + sign.GET_SELECTEDDEVICE,
  SIGN_GET_SELECTEDDEVICE_SEAL: signPrefix + sign.GET_SELECTEDDEVICE_SEAL,
  SIGN_MUT_ADD_USER_CERT: signPrefix + sign.MUT_ADD_USER_CERT,
  SIGN_MUT_DEL_USER_CERT: signPrefix + sign.MUT_DEL_USER_CERT,
  SIGN_MUT_CLEAR_USER_CERTS: signPrefix + sign.MUT_CLEAR_USER_CERTS,
  SIGN_MUT_CLOUD: signPrefix + sign.MUT_CLOUD,
  SIGN_MUT_CLOUD_SEAL: signPrefix + sign.MUT_CLOUD_SEAL,
  SIGN_MUT_CLOUD_PROVIDER: signPrefix + sign.MUT_CLOUD_PROVIDER,
  SIGN_MUT_CLOUD_PROVIDER_SEAL: signPrefix + sign.MUT_CLOUD_PROVIDER_SEAL,
  SIGN_MUT_AUTOSELECTCN: signPrefix + sign.MUT_AUTOSELECTCN,
  SIGN_MUT_SELECTEDTAB: signPrefix + sign.MUT_SELECTEDTAB,
  SIGN_MUT_SELECTEDCN: signPrefix + sign.MUT_SELECTEDCN,
  SIGN_MUT_AUTOSELECTCNSEAL: signPrefix + sign.MUT_AUTOSELECTCNSEAL,
  SIGN_MUT_SELECTEDTABSEAL: signPrefix + sign.MUT_SELECTEDTABSEAL,
  SIGN_MUT_SELECTEDCNSEAL: signPrefix + sign.MUT_SELECTEDCNSEAL,
  SIGN_MUT_SHOWALLDEVICES: signPrefix + sign.MUT_SHOWALLDEVICES,
  SIGN_MUT_SHOWALLDEVICES_SEAL: signPrefix + sign.MUT_SHOWALLDEVICES_SEAL,
  SIGN_MUT_SELECTEDDEVICE: signPrefix + sign.MUT_SELECTEDDEVICE,
  SIGN_MUT_SELECTEDDEVICE_SEAL: signPrefix + sign.MUT_SELECTEDDEVICE_SEAL,

  FILEFOLD_ACT_CURFOLDERSET: filefoldersPrefix + filefold.ACT_CURFOLDERSET,
  FILEFOLD_GET_CURFOLDER: filefoldersPrefix + filefold.GET_CURFOLDER,

  SETTTEMP_GET_ISSHOWMSG: settingsTemp + settTmp.GET_ISSHOWMSG,
  SETTTEMP_GET_ACCESSTOKEN: settingsTemp + settTmp.GET_ACCESSTOKEN,
  SETTTEMP_GET_SIGNALRCONNECTED: settingsTemp + settTmp.GET_SIGNALRCONNECTED,
  SETTTEMP_GET_UNREGUSERTOKEN: settingsTemp + settTmp.GET_UNREGUSERTOKEN,
  SETTTEMP_GET_SIGNLIBFILESSERVERVERSION: settingsTemp + settTmp.GET_SIGNLIBFILESSERVERVERSION,
  SETTTEMP_MUT_ISSHOWMSG: settingsTemp + settTmp.MUT_ISSHOWMSG,
  SETTTEMP_MUT_ACCESSTOKEN: settingsTemp + settTmp.MUT_ACCESSTOKEN,
  SETTTEMP_MUT_SIGNALRCONNECTED: settingsTemp + settTmp.MUT_SIGNALRCONNECTED,
  SETTTEMP_MUT_UNREGUSERTOKEN: settingsTemp + settTmp.MUT_UNREGUSERTOKEN,
  SETTTEMP_MUT_SIGNLIBFILESSERVERVERSION: settingsTemp + settTmp.MUT_SIGNLIBFILESSERVERVERSION,

  COMPONENTS_GET_DATA: componentsPrefix + componentsActions.GET_DATA,
  COMPONENTS_MUT_DATA: componentsPrefix + componentsActions.MUT_DATA,
  COMPONENTS_MUT_RESET: componentsPrefix + componentsActions.MUT_RESET,

  MODULES_ACT_LOADDATA: modulesPrefix + modulesActions.ACT_LOADDATA,
  MODULES_ACT_LOADADMINDATA: modulesPrefix + modulesActions.ACT_LOADADMINDATA,
  MODULES_GET_MODULESTARIFFS: modulesPrefix + modulesActions.GET_MODULESTARIFFS,
  MODULES_GET_ADMINMODULESTARIFFS: modulesPrefix + modulesActions.GET_ADMINMODULESTARIFFS,
  MODULES_GET_USERMODULES: modulesPrefix + modulesActions.GET_USERMODULES,
  MODULES_GET_ADMINUSERMODULES: modulesPrefix + modulesActions.GET_ADMINUSERMODULES,
  MODULES_MUT_ADMINDATACLEAR: modulesPrefix + modulesActions.MUT_ADMINDATACLEAR,

  DOCSIGN_ACT_LOAD_SIGNATURES: documentSignaturesTempPrefix + documentSignaturesTempActions.ACT_LOAD_SIGNATURES,
  DOCSIGN_MUT_SAVE_SIGNATURES: documentSignaturesTempPrefix + documentSignaturesTempActions.MUT_SAVE_SIGNATURES,
  DOCSIGN_MUT_CLEAR_SIGNATURES: documentSignaturesTempPrefix + documentSignaturesTempActions.MUT_CLEAR_SIGNATURES,
  DOCSIGN_GET_SIGNATURES: documentSignaturesTempPrefix + documentSignaturesTempActions.GET_SIGNATURES
};
